import { noop } from '@chegg/utils';
import { useQuery } from '@apollo/client';
import { GET_SUBSCRIPTION_AUTO_APPLY_COUPON_CACHE } from '../gql/queries';
import { useEffect } from 'react';
import { readCampaignCookie } from './useCampaignCookie';
/**
 * Make call to getSubscriptionAutoApplyCouponCache
 * @param options
 * @returns SubscriptionAutoApplyCouponCache
 */
var useCachedCoupon = function useCachedCoupon(input, options) {
  var _data$subscriptionAut, _data$subscriptionAut2;
  var skip = options === null || options === void 0 ? void 0 : options.skip;
  var _useQuery = useQuery(GET_SUBSCRIPTION_AUTO_APPLY_COUPON_CACHE, {
      variables: {
        input: input
      }
    }),
    data = _useQuery.data,
    loading = _useQuery.loading,
    error = _useQuery.error,
    couponRefetch = _useQuery.refetch;
  var campaignCookie = readCampaignCookie();
  useEffect(function () {
    if (!campaignCookie) {
      // refetch cached coupons when a new coupon is cached
      couponRefetch();
    }
  }, [campaignCookie]);
  if (skip) {
    return {
      data: undefined,
      loading: false,
      refetch: noop
    };
  }
  var couponCode = data === null || data === void 0 || (_data$subscriptionAut = data.subscriptionAutoApplyCouponCache) === null || _data$subscriptionAut === void 0 || (_data$subscriptionAut = _data$subscriptionAut.couponCache) === null || _data$subscriptionAut === void 0 || (_data$subscriptionAut = _data$subscriptionAut[0]) === null || _data$subscriptionAut === void 0 ? void 0 : _data$subscriptionAut.couponCode;
  var campaignName = data === null || data === void 0 || (_data$subscriptionAut2 = data.subscriptionAutoApplyCouponCache) === null || _data$subscriptionAut2 === void 0 || (_data$subscriptionAut2 = _data$subscriptionAut2.couponCache) === null || _data$subscriptionAut2 === void 0 || (_data$subscriptionAut2 = _data$subscriptionAut2[0]) === null || _data$subscriptionAut2 === void 0 ? void 0 : _data$subscriptionAut2.name;
  return {
    data: data,
    loading: loading,
    error: error,
    refetch: couponRefetch,
    couponCode: couponCode,
    campaignName: campaignName
  };
};
export default useCachedCoupon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/hooks/useCachedCoupon.js
// module id = 4121
// module chunks = 11